/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionInformationsMutation from '../graphql/mutations/SaveSouscriptionInformationsMutation.js';

export const useSaveSouscriptionInformationsMutation = () => {
  return useCommitMutation(SaveSouscriptionInformationsMutation, {
    dataProp: 'saveSouscriptionInformations_M_souscription_informations'
  });
};

export default useSaveSouscriptionInformationsMutation;
